export default "__VITE_ASSET__WCtQWAUr__"